import React from 'react'
import Header from '../../Header/Header'

const MyOfferletter = () => {
  return (
    <div>
    <Header/>
    </div>
  )
}

export default MyOfferletter